module.exports = __webpack_public_path__ + "img/micromall_online03.d0a0cc85.png";